import React, { useEffect, useState } from "react";
import { loginAdmin } from "../Service/apiService";
import { useNavigate } from "react-router-dom";
import "../assets/css/Login.css";
import { FiMail, FiLock, FiEye, FiEyeOff, FiArrowRight } from "react-icons/fi";
import Header from "../Components/Header";
import { toast } from "react-toastify";
import { isTokenExpired} from "../utils/auth";
import { setupAutoLogout } from "../utils/autoLogout";


const LoginPage = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState("");
  const navigate = useNavigate();

  // useEffect(() => {
  //   const token = localStorage.getItem("token");
  //   if (token) navigate("/", { replace: true });
  // }, [navigate]);

  // Replace your current useEffect with:
useEffect(() => {
  const token = localStorage.getItem("token");
  if (token && !isTokenExpired(token)) {
    navigate("/analytics/daily-data", { replace: true }); // or wherever you want
  }
  // If token exists but is expired → do nothing, let user log in
}, [navigate]);


  // const handleLogin = async (e) => {
  //   e.preventDefault();
  //   setError("");
  //   setIsLoading(true);

  //   const beforetoken = await loginAdmin(email, password);
  //   console.log("before",beforetoken);
    

  //   try {
  //      if(beforetoken.token === beforetoken.token){
  //       console.log("Login not successful");
  //     }
  //     const res = await loginAdmin(email, password);
     
  //     console.log("res",res.token);
      
  //     localStorage.setItem("token", res.token);
  //     navigate("/");
  //   } catch (err) {
  //     setError(err.message || "Invalid email or password");
  //     setIsLoading(false);
  //   }
  // };

  const handleLogin = async (e) => {
  e.preventDefault();
  setError("");
  setIsLoading(true);

  try {
    const res = await loginAdmin(email, password); // Only ONE call

    if (!res?.token) {
      throw new Error("Invalid login response");
    }

    localStorage.setItem("token", res.token);
    setupAutoLogout(res.token, navigate); // 👈 Start auto-logout
    navigate("/analytics/daily-data"); // or "/" — but your app redirects root to /analytics/daily-data
  } catch (err) {
    setError(err.message || "Invalid email or password");
  } finally {
    setIsLoading(false);
  }
};

  return (
    <>
      <Header />

      <div className="login-page-wrapper">
        {/* OUTSIDE CARD HEADING */}
        <h1 className="login-title">Login to your account</h1>

        <div className="login-card">
          <form onSubmit={handleLogin} className="login-form">
            {/* EMAIL */}
            <div className="modern-input">
              <FiMail />
              <input
                type="email"
                placeholder="Enter Your Registered Email Address"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                required
                disabled={isLoading}
              />
            </div>

            {/* PASSWORD */}
            <div className="modern-input">
              <FiLock />
              <input
                type={showPassword ? "text" : "password"}
                placeholder="Enter Your Password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                required
                disabled={isLoading}
              />
              <button
                type="button"
                onClick={() => setShowPassword((p) => !p)}
                className="eye-btn"
              >
                {showPassword ? <FiEye /> : <FiEyeOff />}
              </button>
            </div>

            {error && <div className="error-message">{error}</div>}

            {/* LOGIN → BUTTON */}
            <button
              type="submit"
              className="login-btn-primary"
              disabled={isLoading}
            >
              {isLoading ? "Logging in..." : "Login"}
              <FiArrowRight />
            </button>
          </form>
        </div>
      </div>
    </>
  );
};

export default LoginPage;
